export default __webpack_public_path__ + "static/media/06.e6c16832.jpg";